export class AmenityModel {
  public id: number;
  public user_id: number;
  public title: string;
  public icon_class: string;
  public image: string;
  public created_at: string;
  public updated_at: string;
  public image_path: string;

  constructor(obj: any) {
    this.id = obj.id ? obj.id : 0;
    this.user_id = obj.user_id ? obj.user_id : 0;
    this.title = obj.title ? obj.title : "";
    this.icon_class = obj.icon_class ? obj.icon_class : "";
    this.image = obj.image ? obj.image : "";
    this.created_at = obj.created_at ? obj.created_at : "";
    this.updated_at = obj.updated_at ? obj.updated_at : "";
    this.image_path = obj.image_path ? obj.image_path : "";
  }
}
